/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React, { Component } from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { uid } from 'react-uid';

// Material UI
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Dialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import { withAuth } from '../../../../../../../../state/ducks/Member/ducks/Auth/Plugin/auth';
import { verifyScopeExist } from '../../../../../../../../state/ducks/Member/ducks/Auth/helper/helper';

const styles = (theme) => ({
    dialogTitle: {
        padding: '8px',
        fontSize: '14px',
        fontWeight: '600',
        [theme.breakpoints.up('sm')]: {
            padding: '16px',
            borderBottom: `1px solid ${theme.palette?.colorDisabled || '#ccc'}`,
            marginBottom: '20px',
        },
    },
    pageCount: {
        padding: '0px 8px 8px',
        fontSize: '13px',
        borderBottom: 'solid 0.3px #e2d5d5',
        boxShadow: '0px 1px 1px #e2d5d5',
        [theme.breakpoints.up('sm')]: {
            marginLeft: '16px',
        },
    },
    modalBox: {
        margin: '10px !important',
        maxHeight: 'calc(100% - 96px)',
        minHeight: 'calc(100% - 96px)',
        maxWidth: 'calc(100% - 28px)',
        minWidth: 'calc(100% - 28px)',
        [theme.breakpoints.down('md')]: {
            minWidth: 'calc(100% - 200px)',
            maxWidth: 'calc(100% - 200px)',
            minHeight: 'calc(100% - 20px)',
            maxHeight: 'calc(100% - 20px)',
        },
        [theme.breakpoints.down('sm')]: {
            minWidth: 'calc(100% - 20px)',
            maxWidth: 'calc(100% - 20px)',
            minHeight: 'calc(100% - 20px)',
            maxHeight: 'calc(100% - 20px)',
        },
        [theme.breakpoints.up('md')]: {
            minWidth: 'calc(100% - 500px)',
            maxWidth: 'calc(100% - 500px)',
            minHeight: 'calc(100% - 20px)',
            maxHeight: 'calc(100% - 20px)',
        },
    },
    menuRootClass: {
        fontSize: '13px',
        textAlign: 'left',
        whiteSpace: 'normal',
        borderBottom: 'solid 0.3px #e2d5d5',
        height: 'auto',
        overflow: 'visible',
        padding: '10px 10px 10px 15px',
    },
    labelRootClass: {
        fontSize: '11.0px',
        '@media screen and (min-width: 601px)': {
            fontSize: '18px',
        },
        top: '4px',
        color: '#0000EE',
        fontWeight: '600',
        textDecoration: 'underline',
        cursor: 'pointer',
    },
    pageLink: {
        cursor: 'pointer',
        borderRadius: '25px',
        padding: '3px 7px',
        border: 'solid 1px #000',
        margin: '0px 5px',
        backgroundColor: '#FFF',
        color: '#000',
        fontWeight: '500',
    },
    pageLinkSelected: {
        cursor: 'pointer',
        borderRadius: '25px',
        padding: '3px 7px',
        border: 'solid 1px #000',
        margin: '0px 5px',
        color: '#FFF',
        backgroundColor: '#000',
        fontWeight: '500',
    },
    searchTextBox: {
        padding: '3px',
        width: '94%',
        [theme.breakpoints.up('sm')]: {
            width: '60%',
            padding: '0 0 0 10px',
            marginTop: '-6px',
        },
    },
    fixedHeader: {
        width: '95%',
        position: 'fixed',
        [theme.breakpoints.down('md')]: {
            width: 'calc(100% - 200px)',
        },
        [theme.breakpoints.down('sm')]: {
            width: 'calc(100% - 20px)',
        },
        [theme.breakpoints.up('md')]: {
            width: 'calc(100% - 500px)',
        },
    },
    dialogContent: {
        marginTop: '140px',
        overflowY: 'auto',
        [theme.breakpoints.up('sm')]: {
            marginTop: '153px',
        },
    },
    closeBtn: {
        position: 'absolute',
        right: '10px',
        top: '5px',
        [theme.breakpoints.up('sm')]: {
            top: '0px',
            right: '0px',
            float: 'right',
        },
    },
    containerCheckbox: {
        margin: '10px 5px',
        [theme.breakpoints.up('sm')]: {
            margin: '10px',
        },
    },
    checkboxLabel: {
        fontSize: '14px',
        [theme.breakpoints.up('sm')]: {
            fontSize: '16px',
        },
    },
    checkbox: {
        width: '16px',
        height: '16px',
        border: `1px solid ${theme.palette.grey4}`,
        padding: '0',
        borderRadius: '3px',
        margin: '10px',
    },
    checkboxChecked: {
        paddingTop: '4px',
        color: theme.palette.grey4,
        border: '1px solid #fff',
    },
});

class AddressBookWidget extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openAddressBook: false,
            searchText: '',
            bookEntriesCollection: [],
            bookEntriesResultSet: [],
        };
    }

    componentDidMount() {
        const { callClearErrors } = this.props;
        this.setBookEntries();
        callClearErrors({
            errType: 'recipientFormClearAllFields',
        });
    }

    componentDidUpdate(prevProps) {
        const { pageOn } = this.props;
        if (prevProps.pageOn !== pageOn) {
            this.setBookEntries();
        }
    }

    onHandleSelection = (selectedAddress) => {
        const { selectedAddress: actionSelectedAddress, userType } = this.props;
        if (userType === 'G') {
            actionSelectedAddress(selectedAddress);
        } else if (userType === 'R') {
            if (selectedAddress && selectedAddress.AddressBookEntryId) {
                actionSelectedAddress(selectedAddress);
            } else {
                actionSelectedAddress({});
            }
        } else {
            actionSelectedAddress({});
        }

        this.setState({
            openAddressBook: false,
        });
    }

    onHandlePageChange = (pageNumber) => {
        const { loadAddressBook } = this.props;
        this.setState({
            searchText: '',
        });
        loadAddressBook(pageNumber);
    }

    setBookEntries = () => {
        const { entries } = this.props;
        const addressList = entries.map((item) => ({
            text: this.getLineAddress(item),
            obj: item,
        }));
        this.setState({
            bookEntriesCollection: addressList,
            bookEntriesResultSet: addressList,
        });
    }

    getLineAddress = (address) => {
        const { userType } = this.props;
        if (address) {
            const profile = address;
            if (userType === 'G') {
                let buildAddress = '';
                buildAddress = (profile.firstName) ? `${buildAddress} ${profile.firstName}` : buildAddress;
                buildAddress = (profile.lastName) ? `${buildAddress} ${profile.lastName}` : buildAddress;
                buildAddress = (profile.address1) ? `${buildAddress} ${profile.address1}` : buildAddress;
                buildAddress = (profile.address2) ? `${buildAddress} ${profile.address2}` : buildAddress;
                buildAddress = (profile.city) ? `${buildAddress} ${profile.city}` : buildAddress;
                buildAddress = (profile.state) ? `${buildAddress} ${profile.state}` : buildAddress;
                buildAddress = (profile.country) ? `${buildAddress} ${profile.country}` : buildAddress;
                buildAddress = (profile.postalCode) ? `${buildAddress} ${profile.postalCode}` : buildAddress;
                return buildAddress.trim();
            }
            const Addresses = profile.Addresses?.[0];
            if (Addresses) {
                let buildAddress = '';
                buildAddress = (profile.FirstName) ? `${buildAddress} ${profile.FirstName}` : buildAddress;
                buildAddress = (profile.LastName) ? `${buildAddress} ${profile.LastName}` : buildAddress;
                buildAddress = (profile.EmployerName) ? `${buildAddress} ${profile.EmployerName}` : buildAddress;
                buildAddress = (Addresses.AddressLineOne) ? `${buildAddress} ${Addresses.AddressLineOne}` : buildAddress;
                buildAddress = (Addresses.AddressLineTwo) ? `${buildAddress} ${Addresses.AddressLineTwo}` : buildAddress;
                buildAddress = (Addresses.City) ? `${buildAddress} ${Addresses.City}` : buildAddress;
                buildAddress = (Addresses.StateProvince) ? `${buildAddress} ${Addresses.StateProvince}` : buildAddress;
                buildAddress = (Addresses.Country) ? `${buildAddress} ${Addresses.Country}` : buildAddress;
                buildAddress = (Addresses.PostalCode) ? `${buildAddress} ${Addresses.PostalCode}` : buildAddress;
                return buildAddress.trim();
            }
        }
        return null;
    }

    getNoResultText = () => {
        const { noOfPages, pageOn } = this.props;
        if (noOfPages > 1) {
            return `Address not found in page ${pageOn + 1}`;
        }
        return 'Address not found';
    }

    getAddressList = (entries) => {
        const { classes } = this.props;
        const addressList = entries.map((item, index) => (
            <MenuItem
                key={uid(item.text, index)}
                data-test="checkout-recipient-form-list-savedAddress"
                classes={{
                    root: classes.menuRootClass,
                }}
                value={item.obj.AddressBookEntryId}
                onClick={() => this.onHandleSelection(item.obj)}
            >
                {item.text}
            </MenuItem>
        ));
        if (addressList.length === 0) {
            return (
                <MenuItem
                    key="menuItem_noresults"
                    classes={{
                        root: classes.menuRootClass,
                    }}
                >
                    {this.getNoResultText()}
                </MenuItem>
            );
        }
        return addressList;
    }

    getPages = (start, end) => new Array(end - start).fill().map((d, i) => i + start);

    getPageLink = () => {
        const { noOfPages, pageOn, classes } = this.props;
        const arrPages = this.getPages(0, noOfPages);
        return arrPages.map((item, index) => {
            if (pageOn === item) {
                return <span key={uid(item, index)} className={classes.pageLinkSelected}>{item + 1}</span>;
            }
            return <span key={uid(item, index)} className={classes.pageLink} onClick={() => { this.onHandlePageChange(item); }}>{item + 1}</span>;
        });
    }

    handleOpenAddressBook = async () => {
        const { isAccessBasedOnScopeEnabled } = this.props;
        if (isAccessBasedOnScopeEnabled) {
            const { auth: { getAccessTokenSafely, loginByRedirect } } = this.props;
            const accesstoken = await getAccessTokenSafely();
            if (verifyScopeExist(accesstoken, 'write:checkout')) {
                this.setState({
                    openAddressBook: true,
                });
            } else {
                await loginByRedirect();
            }
        } else {
            this.setState({
                openAddressBook: true,
            });
        }
    }

    handleSearchTextChange = (event) => {
        const { bookEntriesCollection } = this.state;
        const strSearchText = event.target.value;
        const addressBookSearchResult = bookEntriesCollection.filter((item) => (
            item.text.toLowerCase().includes(strSearchText.toLowerCase())
        ));
        this.setState({
            searchText: event.target.value,
            bookEntriesResultSet: addressBookSearchResult,
        });
    }

    handleCloseAddressBook = () => {
        const { handleClearSelectedAddressBook } = this.props;
        this.setState({
            openAddressBook: false,
        });
        handleClearSelectedAddressBook();
    }

    render() {
        const {
            label, name, classes, totalAddresses, entries, userType,
            handleShipAllGifts, totalOrderItems, valueUseAddressForAll,
        } = this.props;
        const { openAddressBook, searchText, bookEntriesResultSet } = this.state;
        const isGuestAddressBook = (userType === 'G');
        let totalNumberOfAddress;
        if (isGuestAddressBook && entries.length > 0) {
            totalNumberOfAddress = entries.length;
        }

        return (
            <Grid>
                <InputLabel
                    id={`il_input_${name}`}
                    data-test="checkout-recipient-form-select-from-savedaddress"
                    key={`il_input_${name}`}
                    shrink
                    htmlFor={name}
                    className={classes.labelRootClass}
                    onClick={this.handleOpenAddressBook}
                >
                    {label}
                </InputLabel>
                <Dialog
                    classes={{
                        paper: classes.modalBox,
                    }}
                    open={openAddressBook}
                    onClose={this.handleCloseAddressBook}
                    data-testid="addressbook-modal"
                >
                    <Grid container className={classes.fixedHeader}>
                        <Grid item xs={12} md={12} lg={12}>
                            <div className={classes.dialogTitle}>
                                Contacts - Total ({isGuestAddressBook ? totalNumberOfAddress : totalAddresses})
                                <IconButton data-test="checkout-recipient-form-savedAddress-close" className={classes.closeBtn} aria-label="Close" onClick={this.handleCloseAddressBook}>
                                    <CloseIcon />
                                </IconButton>
                            </div>
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <Typography className={classes.pageCount} component="span" variant="h6" id="modal-title">
                                Page :  {this.getPageLink()}
                            </Typography>
                            { /* Search Text Box */}
                            <TextField
                                id="addressBookSearchText"
                                value={searchText}
                                className={classes.searchTextBox}
                                onChange={this.handleSearchTextChange}
                                placeholder="Search Address"
                            />
                        </Grid>
                        {totalOrderItems > 1 && (
                            <Grid item xs={12} md={12} lg={12}>
                                <FormControlLabel
                                    control={(
                                        <Checkbox
                                            id="checkboxShipAllGiftsToThisAddress"
                                            data-testid="checkboxShipAllGiftsToThisAddress" // unit test
                                            data-test="checkout-ship-all-gifts-to-this-address"
                                            color="default"
                                            icon={<div style={{ maxWidth: '24px' }} />}
                                            checked={valueUseAddressForAll}
                                            onChange={handleShipAllGifts}
                                            classes={{
                                                root: classes.checkbox,
                                                checked: classes.checkboxChecked,
                                            }}
                                        />
                                    )}
                                    label={(<Typography className={classes.checkboxLabel}>SHIP ALL GIFTS TO THIS ADDRESS</Typography>)}
                                    className={classes.containerCheckbox}
                                />
                            </Grid>
                        )}
                    </Grid>
                    <Grid className={classes.dialogContent}>
                        {this.getAddressList(bookEntriesResultSet)}
                    </Grid>
                </Dialog>
            </Grid>
        );
    }
}

AddressBookWidget.propTypes = {
    entries: PropTypes.array,
    label: PropTypes.string,
    selectedAddress: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    loadAddressBook: PropTypes.func.isRequired,
    noOfPages: PropTypes.number,
    pageOn: PropTypes.number,
    classes: PropTypes.object.isRequired,
    totalAddresses: PropTypes.number.isRequired,
    userType: PropTypes.string,
    totalOrderItems: PropTypes.number,
    handleShipAllGifts: PropTypes.func,
    valueUseAddressForAll: PropTypes.bool,
    handleClearSelectedAddressBook: PropTypes.func,
    callClearErrors: PropTypes.func,
    auth: PropTypes.shape({
        loginByRedirect: PropTypes.func.isRequired,
        getAccessTokenSafely: PropTypes.func.isRequired,
    }).isRequired,
    isAccessBasedOnScopeEnabled: PropTypes.bool,
};

AddressBookWidget.defaultProps = {
    entries: [],
    label: 'Select an address from your contacts',
    userType: 'R',
    noOfPages: 1,
    pageOn: 1,
    totalOrderItems: null,
    handleShipAllGifts: () => { },
    valueUseAddressForAll: false,
    handleClearSelectedAddressBook: () => { },
    callClearErrors: () => { },
    isAccessBasedOnScopeEnabled: false,
};

export default compose(
    withAuth,
    withStyles(styles),
)(AddressBookWidget);
